export function getItemOptions() {
  const { renderItem, renderCollapseIcon, handler, childrenProp } = this.props;
  const { dragItem } = this.state;

  return {
    dragItem,
    childrenProp,
    renderItem,
    renderCollapseIcon,
    handler,

    onDragStart: this.onDragStart,
    onMouseEnter: this.onMouseEnter,
    isCollapsed: this.isCollapsed,
    onToggleCollapse: this.onToggleCollapse,
  };
}
